 <template>
	<div class="page">

		<!-- 搜索条件表单 -->
		<el-form class="ser_form" size="small"  label-width="100px">
			<el-form-item class="el_form_item" label="运单编号">
				<el-input class="el_input" v-model="form.truck_tord_num" clearable></el-input>
			</el-form-item>
			<el-form-item class="el_form_item" label="货主手机">
				<el-input class="el_input" v-model="form.shipper_tel" clearable></el-input>
			</el-form-item>
			<el-form-item class="el_form_item" label="公司名称">
				<el-input class="el_input" v-model="form.company_name" clearable></el-input>
			</el-form-item>
			<el-form-item class="el_form_item" label="司机姓名">
				<el-input class="el_input" v-model="form.driver_name" clearable></el-input>
			</el-form-item>
			<el-form-item class="el_form_item" label="司机手机号">
				<el-input class="el_input" v-model="form.driver_tel" clearable></el-input>
			</el-form-item>
			<el-form-item class="el_form_item" label="信用状态">
				<el-select class="el_input" v-model="form.state" clearable>
					<el-option label="不限" value=""></el-option>
					<el-option label="正常" value="1"></el-option>
					<el-option label="隐藏" value="2"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item class="el_form_item elfrom_item" label="创建时间" style="	margin-right: 150px;">
				<div class="block">
				<el-date-picker
					v-model="build_date"
					type="datetimerange"
					:picker-options="pickerOptions"
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					align="right"
					value-format="timestamp"
				>
				</el-date-picker>
				</div>
			</el-form-item>
			<el-form-item label-width="0" id="button" style="margin-left: 50px;">
				<el-button type="primary" @click="page_ser">查询</el-button>
				<el-button type="primary" @click="ser_para_clear">清空条件</el-button>
			</el-form-item>
		</el-form>
		<div class="total_info item">
			<span>共:{{ list.total }}条</span>
		</div>
		<!-- 表格 -->
		<div class="tab_height">
			<el-table :data="list.data" :border="true" :stripe="true" size="small" height="100%" v-loading="list.loading">
				<el-table-column type="selection" width="39px"></el-table-column>
                <el-table-column label="id" prop="id"></el-table-column>
                <el-table-column label="运单编号" prop="truck_tord_num"></el-table-column>
				<el-table-column label="创建时间" prop="creat_time_text"></el-table-column>
                <el-table-column label="货主手机号" prop="shipper_tel"></el-table-column>
                <el-table-column label="公司名称" prop="company_name"></el-table-column>
                <el-table-column label="司机姓名" prop="driver_name"></el-table-column>
                <el-table-column label="司机手机号" prop="driver_tel"></el-table-column>
                <el-table-column label="信用备注" prop="content"></el-table-column>
                <el-table-column label="信用评分" prop="credit"></el-table-column>
                <el-table-column label="状态" prop="status_text"></el-table-column>
				<!-- 操作行 -->
				<el-table-column label="操作" width="142">
					<template slot-scope="scope">
						<el-button class="btn_left" @click="credit_dele(scope.row)" size="mini" type="text">删除</el-button>
					</template>
				</el-table-column>
				<!-- <el-table-column label="驳回原因">
					<template slot-scope="scope">
						{{scope.row.check_faild_reason}}
					</template>
				</el-table-column> -->
				<!-- 操作行 -->
			</el-table>
		</div>

		<!-- 分页 -->
		<el-pagination 
			class="margin-top-xl" 
			@size-change="page_size_change"
			@current-change="page_current_change" 
			:current-page="page.p" 
			:page-sizes="[10, 20, 30, 40]"
			:page-size="page.num" 
			:total="list.total*1"
			layout="total, sizes,prev, pager, next, jumper" 
		>
		</el-pagination>
	</div>
</template>

<script>
	import { mapState} from 'vuex'
	export default {
		components:{
		},
		data() {
			return {

				//bucket
				bucket:{},
				bucket_loaded:false,
				
				//搜索条件
				form: {				
					truck_tord_num:'',//运单编号
					shipper_tel:'',//货主手机号码
					company_name:'',//公司名称

					driver_name:'',//司机姓名
					driver_tel:'',//司机手机号
					state:'',//信用状态
					min_time:'',//开始时间
					max_time:'',//结束时间
				},

				//表格数据
				list: {
					loading: false,//loading特效
					data: [],//列表数据
					total: 0,//列表总记录数
				},

				//页码信息
				page: {
					need_num:1,
					num: 10,
					p: 1,
				},
				build_date:'',//创建时间
				//时间快捷操作
			    pickerOptions: {
					shortcuts: [
					{
						text: "最近一周",
						onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
						picker.$emit("pick", [start, end]);
						},
					},
					{
						text: "最近一个月",
						onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
						picker.$emit("pick", [start, end]);
						},
					},
					{
						text: "最近三个月",
						onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
						picker.$emit("pick", [start, end]);
						},
					},
					],
				},
			}
		},
		created() {
			
			//获取页面数据
			this.get_page_data()
			
		},
		methods: {
			//删除
			credit_dele(item){
					this.$my.other.confirm({
					content:"是否确认提交删除?",
					confirm:()=>{
						this.$my.net.req({
							data:{
								mod:'truck_tord_real_time',
								ctr:'shipper_credit_del_admin',
								id:item.id,
							},callback:(res)=>{
								this.$my.other.msg({
									str:'操作成功',
									type:'success'
								});
								this.get_page_data()
							}
						})
					}
				});
			},
			//清空查询条件
			ser_para_clear(){
				this.form={
					truck_tord_num:'',//运单编号
					shipper_tel:'',//货主手机号码
					company_name:'',//公司名称

					driver_name:'',//司机姓名
					driver_tel:'',//司机手机号
					state:'',//信用状态
					min_time:'',//开始时间
					max_time:'',//结束时间
				}

				this.build_date = "";
				this.page.p =1
				this.get_page_data()
			},
			

			//搜索
			page_ser(){

				//读取第一页
				this.page.p=1

				//读取
				if (this.build_date) {
					this.form.min_time = parseInt(this.build_date[0] / 1000);
					this.form.max_time = parseInt(this.build_date[1] / 1000);
				} else {
					this.form.min_time = "";
					this.form.max_time = "";

				}
				 
				this.page.p = 1;
				this.get_page_data();
			},

			//页宽变化
			page_size_change(num){

				//置入页码
				this.page.num=num

				//读取
				this.get_page_data()
			},

			//页码变化
			page_current_change(p){
				
				//置入页码
				this.page.p=p

				//读取
				this.get_page_data()
			},

			//读取页面数据
			get_page_data(){
				//加载中...
				if(this.list.loading){
					return;
				}

				//置为加载中
				this.list.loading=true;
				//读取数据
				this.$my.net.req({
					take_over_control:1,
					data:{
						mod:'truck_tord_real_time',
						ctr:'shipper_credit_list_admin',
						is_get_app_user_info:1,
						...this.form,
						...this.page
					},
					callback:(data)=>{
						//加载完毕
						this.list.loading=false
						if(data.code !=0){
							this.$my.other.msg({
								type:'info',
								str:data.error_info,
							});
							this.list.data=[]
							return
						}
					

						//总数
						this.list.total=data.msg.max

						//预处理
						for(let item of data.msg.list){
							//创建时间
							item.creat_time_text=this.$my.other.totime(item.create_time);
							item.shipper_creat_time_text=this.$my.other.totime(item.shipper_creat_time);
							//是否可用
							switch(item.state){
								case '0':item.status_text='全部';break;
								case '1':item.status_text='正常';break;
								case '2':item.status_text='隐藏';break;
							}
							
						}

						//渲染
						this.list.data=data.msg.list
					}
				})
			},
		}
	}
</script>

<style lang="scss" scoped>

	//弹出层
	.in_tab_img_item{
		width: 500px;
	}

	//用户修改/添加表单的额外权限菜单部分
	.menu_list{
		background-color:#eee;
		height: 500px;
		overflow: auto;
		padding: 0 20px;
		margin-top: 10px;
		.children_list{
			margin-left: 20px;
		}
	}

	//其他
	.page{
		background-color: #fff;
		padding: 20px;
		border-radius: 10px;
		height: calc(100% - 40px);
		overflow: auto;
	}
	.ser_form{
		display: flex;
		align-items: flex-end;
		flex-wrap: wrap;
	}
	.tab_height{
		height:calc(100% - 140px);
	}
	.el_form_item{
		width: 20%;
	}
	.el_input{
		width:94%
	}
	.btn_left{
		margin: 0;
	}
	.total_info {
	text-align: right;
	font-size: 12px;
	margin-bottom: 24px;
	margin-right: 1px;
	margin-top: 10px;
	color: #606266;
		span {
			margin-left: 20px;
		}
	}
	.item {
	font-weight: 800;
	}
	#button{
		margin-left: -120px;
	}
	.green{
		color: rgb(13, 230, 13);
	}
	.red{
		color: red;
	}
</style>